<template>
  <div>
    <div v-if="switchboard">
      <h4>Details for {{switchboard.title}}</h4>
      <b-form>
        <b-form-group v-for="(field, i) in fields" :key="'field-'+i">
          <label class="field-label" for="field">{{field[1]}}</label>
          <div class="field-value">{{switchboard[field[0]] || '---'}}</div>
          <hr />
        </b-form-group>
        <BFR :node="switchboard.node" />
      </b-form>
    </div>
  </div>
</template>

<script>
import BFR from "./BFR.vue";

export default {
  name: "switchboard",
  components: {
    BFR
  },
  props: {
    switchboard: {}
  },
  data: () => ({
    loading: false,
    errors: [],
    filter: "",
    fields: [
      ["title", "Title"],
      ["manufacturer", "Manufacturer"],
      ["brand", "Brand"],
      ["enclosureType", "Enclosure Type"],
      ["maxSupplyRating", "Maximum Supply Rating"],
      ["phase", "Phase"],
      ["wire", "Wire"],
      ["voltageRating", "Voltage Rating"],
      ["hz", "Hz"],
      ["maxSectionRating", "Maximum Section Rating"],
      ["plantCode", "Plant Code"],
      ["catalogNo", "Catalog NO."],
    ]
  }),
  methods: {}
};
</script>

<style lang="scss" scoped>
</style>
